








import { Vue, Component, Prop } from 'vue-property-decorator'
@Component
export default class Copy extends Vue {
    @Prop(String) private value!: string
    private copied = false
    private async copy() {
        const value = this.value
        if (value) {
            try {
                await this.$copyText(value)
                this.copied = true
                setTimeout(() => { this.copied = false }, 2000)
                // tslint:disable-next-line:no-empty
            } catch (err) {
            }
        }
    }
}
